import { Box, Card, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export const SearchTableStaleState = function ({ searchFor }) {
  return (
    <Card
      sx={{
        border: 1,
        borderColor: "divider",
        py: 8,
        px: 2,
        textAlign: "center",
        boxShadow: "none",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
        <Box
          sx={{
            p: 1.5,
            bgcolor: "action.hover",
            borderRadius: 2,
            display: "flex",
          }}
        >
          <SearchIcon sx={{ fontSize: 32, color: "text.secondary" }} />
        </Box>
      </Box>

      <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
        No search performed
      </Typography>

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ maxWidth: 360, mx: "auto" }}
      >
        Search for a {searchFor} to view results.
      </Typography>
    </Card>
  );
};
